import styled, { css } from 'styled-components';
import StyleGuide from 'src/style-guide';

export const Title = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.utils.pxToRem(20)}rem;
    margin: ${theme.utils.pxToRem(28)}rem 0 ${theme.utils.pxToRem(24)}rem;
  `}
  font-weight: 700;
  color: #393d45;
`;

export const Modal = styled(StyleGuide.Modal)`
  width: 440px;
  padding: 0;
  border: none;
`;

export const ButtonGroup = styled.div`
  ${({ theme }) => css`
    margin: ${theme.utils.pxToRem(28)}rem 0;
    height: ${theme.utils.pxToRem(34)}rem;
  `}
  position: relative;
`;

export const ButtonStyles = css`
  margin-bottom: 0;
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  font-size: 12px;
  line-height: 12px;
  padding: 10px 12px;
`;

export const CancelButton = styled.button`
  ${ButtonStyles}
  border-radius: 3px;
  position: absolute;
  width: 168px;
  left: 0;
  letter-spacing: 1px;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.licorice};
    color: ${theme.colors.licorice};
  `}

  &:hover {
    ${({ theme }) => css`
      background-color: ${theme.colors.alizarinCrimson};
      border: 1px solid ${theme.colors.alizarinCrimson};
      color: ${theme.colors.white};
    `}
  }

  &:focus {
    ${({ theme }) => css`
      background-color: ${theme.colors.white};
      border: 1px solid ${theme.colors.licorice};
      color: ${theme.colors.licorice};
    `}
  }
`;

export const SaveButton = styled.button`
  ${ButtonStyles}
  position: absolute;
  right: 0;
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};
  width: 168px;
  border-radius: 3px;
  letter-spacing: 1px;
`;

export const SaveDescription = styled.div`
  padding: 0 10px;
  opacity: 0.7;
  font-size: ${({ theme }) => theme.utils.pxToRem(14)}rem;
  line-height: 18px;
`;

export const CloseModalIconContainer = styled.div`
  position: absolute;
  cursor: pointer;

  ${({ theme }) => css`
    top: ${theme.utils.pxToRem(16)}rem;
    right: ${theme.utils.pxToRem(16)}rem;
    width: ${theme.utils.pxToRem(16)}rem;
    height: ${theme.utils.pxToRem(16)}rem;
  `}

  .hv-svg svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;

    path {
      fill: ${({ theme }) => theme.colors.defaultGray};
    }
  }
  &:hover {
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;

export const ModalContent = styled.div`
  text-align: center;
  padding: 0 40px;
`;

export const WarningBar = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
  line-height: 40px;
  font-size: ${({ theme }) => theme.utils.pxToRem(11)}rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.borderError};
`;

export const WarningIconContainer = styled.div`
  position: absolute;
  left: 20px;
  align-self: center;
  .hv-svg svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const WarningUpArrow = styled.div`
  position: absolute;
  bottom: 34px;
  right: 120px;
  height: 12px;
  width: 12px;
  background-color: ${({ theme }) => theme.colors.borderError};
  transform: rotate(45deg);
`;
